import { Box, IconButton } from '@chakra-ui/react';

import DevSandboxTooltip from './DevSandbox/DevSandboxTooltip';
import useSandboxTheme from './DevSandbox/useSandboxTheme';
import GradientPopover from './GradientPopover';
import Icon from './Icon';
import Text from './Text';
import ToggleCodePrivacySwitch, { IToggleCodePrivacySwitchProps } from './ToggleCodePrivacySwitch';

interface IToggleCodePrivacyLockProps extends IToggleCodePrivacySwitchProps {}

const ToggleCodePrivacyLock = ({ ...switchProps }: IToggleCodePrivacyLockProps) => {
  const { colors } = useSandboxTheme();

  return (
    <DevSandboxTooltip label="Toggle code privacy">
      <Box display="inline-block">
      <GradientPopover
        triggerComponent={
        <IconButton
          aria-label="Toggle code privacy"
          size="md"
          variant="outline"
          borderColor={colors.controlBorder}
          color={colors.textSecondary}
          bg={colors.controlBg}
          _hover={{
            color: colors.textPrimary,
            bg: colors.hoverBg,
            borderColor: colors.controlBorderHover,
          }}
          _active={{ bg: colors.activeBg }}
        >
          {switchProps.togglePrivacyCodeParams.isPrivate ? (
            <Icon type="PrivateCodeLock" />
          ) : (
            <Icon type="PublicCodeLock" />
          )}
        </IconButton>
      }
      header={<Text fontSize="large" width="100%">Toggle code privacy</Text>}
    >
        <ToggleCodePrivacySwitch {...switchProps} />
      </GradientPopover>
      </Box>
    </DevSandboxTooltip>
  );
};

export default ToggleCodePrivacyLock;
